const signals = require('../../../../../signals/account/orders');
const { cut } = require('../../../../../helpers/utils');
const css = require('./styles.css');

const LOAD_FILE_RESULT_BUTTON_SELECTOR = cut(css.fileResultUploadInput);

class ExportResultUpload {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            change: {
                [LOAD_FILE_RESULT_BUTTON_SELECTOR]: this.uploadResultDocument
            }
        };
    }

    uploadResultDocument (e) {
        const file = e.target.files[0];

        this.$context.signal(signals.uploadResultDocument, { file });
    }
}

module.exports = {
    constructor: ExportResultUpload
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/export-result-upload/index.js